/* eslint-disable */
import React, { Component } from 'react';
import history from "./history";
import { BrowserRouter as Router} from "react-router-dom";
import { Row, Col} from 'react-bootstrap';

import Call from "./components/Call";
import About from "./components/About";
import Program from "./components/Program";
import Postponement from "./components/Postponement";
import Exhibition from "./components/Exhibition";


let availableRoutes = ['about', 'call-for-posters', 'program', 'postponement', 'exhibition', 'live'];
let PATH = '/2020/';

class Wrapper extends Component {
    constructor(props) {
        super(props);

        let isOpen = false;
        let div = null;

        for (let route of availableRoutes) {
            //console.log (window.location.pathname);
            if (window.location.pathname === PATH + route) {
                isOpen = true;
                div = this.getDiv(PATH + route);
                break;
            }
        }

        this.state={
            'color':props.c,
            'open':isOpen,
            'wrapper': div
        }

        this.open = this.open.bind();
    }

    open = (path) => {
        history.push(path);
        let div = this.getDiv(path);
        this.setState({open:true, wrapper: div});
    };

    close = (e) => {
        history.push(PATH);
        this.setState({open:false});

        // desactive links
        let els = document.querySelectorAll(".active");
        let navs = document.querySelectorAll(".responsive-header-color");

        for (let el of els){
            el.classList.remove("active");
        }

        for (let nav of navs){
            nav.classList.remove("responsive-header-color");
        }



    };


    getDiv = (path) => {
        let div = null
        if (path === PATH + availableRoutes[0]) {
            div = <About/>;
        } else if (path === PATH + availableRoutes[1]) {
            div = <Call/>
        } else if (path === PATH + availableRoutes[2]) {
            div = <Program/>
        } else if (path === PATH + availableRoutes[3]) {
            div = <Postponement/>
        } else if (path === PATH + availableRoutes[4]) {
            div = <Exhibition/>
        }
        return div;
    }

    render(){
        let classList = ['information','independent-scroll', 'pt-5'];
        if (this.state.open) {
            classList.push ('is-nav-open');
        }
        return (
            <Row>
                <Router history={history}>
                        <div className="aside-container">
                            <Col ref={this.wrapperRef}  style={{backgroundColor: this.state.color}}
                                 className={classList}
                                 sm={{span:12, offset:12}}
                                 lg={{span:6, offset:6}}>
                                <Row className="p-4">
                                    <Col className="mobile-pt-2" lg={12}>
                                    <span onClick={(e) => this.close(e)} className="close-wrapper">&times;</span>
                                    </Col>
                                    <Col xs={12} md={12} lg={12}>
                                        {this.state.wrapper}
                                    </Col>
                                </Row>
                                <div className="spacing"/>
                            </Col>
                        </div>
                </Router>
            </Row>
        );
    }

}


export default Wrapper;